import Vue from 'vue'

import parsleyMaterialize from './parsley-materialize'
import 'webpack-material-design-icons'
import $ from 'jquery'
window.$ = require('jquery')
window.jQuery = require('jquery')
import 'datatables'
import './common/datatable.js'
import 'materialize-css/bin/materialize.js'
import 'bootstrap-tagsinput'
import 'bootstrap-tagsinput/dist/bootstrap-tagsinput.css'

// collapsed menu
 // $('.button-collapse').dropdown({
 //   inDuration: 300,
 //   outDuration: 225,
 //   constrain_width: false, // Does not change width of dropdown to that of the activator
 //   hover: false, // Activate on hover
 //   gutter: 0, // Spacing from edge
 //   belowOrigin: false, // Displays dropdown below the button
 //   alignment: 'left' // Displays dropdown with edge aligned to the left of button
 // })

function bootstrapTagsInputFix($input) {

  // materialize label animation fix
  var id = $input.attr('id')
  var $label = $(`label[for=${id}]`)
  $label.click(function() {
    $input.tagsinput('focus')
  })
  $input.tagsinput('input').on('focus', function() {
    // adding some random character to cause the animated label to go up then remove that char
    $input.tagsinput('add', 'o')
    $input.tagsinput('remove', 'o')
  })

  // prevent to write " char in the input (which cause an error in tagsinput)
  $input.tagsinput('input').keypress((e) => {
    return e.key !== '"'
  })

}

export default function init() {

  $(document).ready(() => {
    // handling chrome autofill problem
    $('input').on('change.autofill', function() {
      $('[for=password]').addClass('active')
    }).click(function() {
      $(this).unbind('change.autofill')
    })

    Vue.nextTick(() => {
      parsleyMaterialize.init()
      window.Parsley.setLocale('hu')
      $('select').material_select()
      window.Materialize.updateTextFields()

      $('.dropdown-button').dropdown({
        inDuration: 300,
        outDuration: 225,
        constrain_width: false, // Does not change width of dropdown to that of the activator
        hover: false, // Activate on hover
        gutter: 0, // Spacing from edge
        belowOrigin: true, // Displays dropdown below the button
        alignment: 'right' // Displays dropdown with edge aligned to the left of button
      })

      $('ul.tabs').tabs()

      if ($('form').length > 0) {
        $('form').parsley()
      }

      // all tagsinputs are for phone numbers currently
      var $tagsinputs = $('input[data-role=tagsinput], select[multiple][data-role=tagsinput]')
      var maxLength = 128
      var maxChars = 12
      var maxTags = Math.floor(maxLength / maxChars)
      $tagsinputs.tagsinput({
        maxTags: maxTags,
        maxChars: maxChars
      })
      $tagsinputs.each(function() {
        bootstrapTagsInputFix($(this))
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/init-js-libs.js